import { BiometricAvailability, BiometricCredentials, BiometricLoginState } from './Biometrics.types';

// La connexion biométrique repose sur des modules natifs (react-native-biometrics,
// react-native-keychain) qui n'existent pas sur le web : on expose ici la même API
// que Biometrics.ts, mais toujours indisponible/no-op, pour que le code partagé
// (packages/app) puisse importer ce module sans condition sur la plateforme.

export const getBiometricAvailability = async (): Promise<BiometricAvailability> => ({ available: false });

export const getBiometryLabel = (_biometryType?: string): string => 'la biométrie';

export const promptBiometricAuth = async (_promptMessage: string): Promise<boolean> => false;

export const isBiometricLoginEnabled = async (): Promise<boolean> => false;

export const getBiometricLoginUsername = async (): Promise<string | null> => null;

export const getBiometricLoginState = async (): Promise<BiometricLoginState> => ({
  availability: { available: false },
  enabled: false,
  username: null,
});

export const enableBiometricLogin = async (_username: string, _password: string): Promise<boolean> => false;

export const disableBiometricLogin = async (): Promise<void> => {};

export const getBiometricCredentials = async (_promptTitle?: string): Promise<BiometricCredentials | null> => null;
